module.exports = __webpack_public_path__ + "img/intellect-scene-1.b0459e98.png";